export const ActionTypes = {
    GET_POSTS: "GET_POSTS",
    SET_POSTS: "SET_POSTS",
    APPEND_POSTS: "APPEND_POSTS",
    SET_HAS_MORE: "SET_HAS_MORE",
    SET_INITIALIZED: "SET_INITIALIZED",
    SET_LOADING: "SET_LOADING",
    DELETE_POST: "DELETE_POST",
    RESET_POSTS: "RESET_POSTS",
    SET_POSTS_TOTAL_ALL: "SET_POSTS_TOTAL_ALL",
    SET_POSTS_ACTIVE: "SET_POSTS_ACTIVE",
    SET_POST_GALLERY_ACTIVE: "SET_POST_GALLERY_ACTIVE",
    UPDATE_POST: "UPDATE_POST",
    CANCEL_POST_FETCH: "CANCEL_POST_FETCH",
    SET_POST_MEDIAS: "SET_POST_MEDIAS",
    SET_POST: "SET_POST",

    SET_DARKMODE: "SET_DARKMODE",

    SET_PROCESSING_FOLLOW: "SET_PROCESSING_FOLLOW",

    SET_STASH_MODAL: "SET_STASH_MODAL",
    SET_ORDER_MODAL: "SET_ORDER_MODAL",
    SET_ACTIVE_ALBUM: "SET_ACTIVE_ALBUM",
    SET_STASH_SIDEBAR: "SET_STASH_SIDEBAR",

    SET_BROADCAST_MODAL: "SET_BROADCAST_MODAL",
    SET_SHOW_POST_ALBUM: "SET_SHOW_POST_ALBUM",
    SET_SHOW_ALERT: "SET_SHOW_ALERT",

    SET_CATEGORIES_IS_BUSY: "SET_CATEGORIES_IS_BUSY",
    SET_CATEGORIES_HAS_MORE: "SET_CATEGORIES_HAS_MORE",
    SET_CATEGORIES: "SET_CATEGORIES",
    DELETE_CATEGORIES: "DELETE_CATEGORIES",
    UPDATE_CATEGORY: "UPDATE_CATEGORY",
    RESET_CATEGORIES: "RESET_CATEGORIES",
    SET_CATEGORIES_MODAL: "SET_CATEGORIES_MODAL",
    SET_CATEGORIES_MODE: "SET_CATEGORIES_MODE",
    SET_OLD_CATEGORY: "SET_OLD_CATEGORY",

    SET_SETTINGS: "SET_SETTINGS",

    SET_FEED: "SET_FEED",
    APPEND_FEED: "APPEND_FEED",
    UPDATE_FEED: "UPDATE_FEED",

    SET_ACTION: "SET_ACTION",
    UPDATE_CC_VERIFICATION: "UPDATE_CC_VERIFICATION",

    SET_USER: "SET_USER",

    SET_STASH: "SET_STASH",
    SET_STASH_MEDIAS: "SET_STASH_MEDIAS",
    SET_STASH_BUSY: "SET_STASH_BUSY",
    SET_STASH_HASMORE: "SET_STASH_HASMORE",
    SET_STASH_GET_INFORMATION: "SET_STASH_GET_INFORMATION",
    SET_STASH_FILTER: "SET_STASH_FILTER",
    SET_STASH_ALBUMS: "SET_STASH_ALBUMS",
    SET_STASH_SELECTED: "SET_STASH_SELECTED",
    SET_STASH_SHOW: "SET_STASH_SHOW",
    SET_STASH_TO_GET_INFO: "SET_STASH_TO_GET_INFO",

    APPEND_CONV_LIST: "APPEND_CONV_LIST",
    SET_CONV_LIST: "SET_CONV_LIST",

    SET_STASH_TAB_SELECTED: "SET_STASH_TAB_SELECTED",
    SET_ALBUM_ACTION: "SET_ALBUM_ACTION",
    SET_NEW_ALBUM_FORM: "SET_NEW_ALBUM_FORM",
    SET_ADD_MEDIA_TO_ALBUM: "SET_ADD_MEDIA_TO_ALBUM",
    SET_STASH_ALBUM_MEDIAS: "SET_STASH_ALBUM_MEDIAS",
    SET_STASH_ACTIVE_ALBUM: "SET_STASH_ACTIVE_ALBUM",
    SET_STASH_ALBUM_GET_INFORMATION: "SET_STASH_ALBUM_GET_INFORMATION",
    SET_STASH_ACTIVE_ALBUM_MEDIAS: "SET_STASH_ACTIVE_ALBUM_MEDIAS",
    SET_STASH_ALBUM_LIST_SCROLL_POSITION:
        "SET_STASH_ALBUM_LIST_SCROLL_POSITION",

    SET_POST_IS_RESET: "SET_POST_IS_RESET",

    SET_STASH_MEDIA_SENT: "SET_STASH_MEDIA_SENT",
    SET_STASH_MEDIA_SOLD: "SET_STASH_MEDIA_SOLD",
    SET_STASH_TYPE: "SET_STASH_TYPE",
    SET_STASH_SORT: "SET_STASH_SORT",
    SET_STASH_FILTER_TO_DATE: "SET_STASH_FILTER_TO_DATE",
    SET_STASH_CURRENT_PAGE: "SET_STASH_CURRENT_PAGE",

    SET_SUBCOVER: "SET_SUBCOVER",

    SET_ONLINE_PRESENCE: "SET_ONLINE_PRESENCE",
    ADD_ONLINE_PRESENCE: "ADD_ONLINE_PRESENCE",

    SET_SHOW_CHAT_GALLERY: "SET_SHOW_CHAT_GALLERY",
    SET_GET_CHAT_GALLERY_IS_BUSY: "SET_GET_CHAT_GALLERY_IS_BUSY",
    SET_CHAT_GALLERY_MEDIA: "SET_CHAT_GALLERY_MEDIA",
    SET_CHAT_GALLERY_FILTER: "SET_CHAT_GALLERY_FILTER",
    SET_CHAT_GALLERY_MESSAGES: "SET_CHAT_GALLERY_MESSAGES",
    SET_CHAT_GALLERY_HAS_MORE: "SET_CHAT_GALLERY_HAS_MORE",
    SET_CHAT_GALLERY_ACTIVE_MESSAGE: "SET_CHAT_GALLERY_ACTIVE_MESSAGE",
    SET_CHAT_GALLERY_SOURCE: "SET_CHAT_GALLERY_SOURCE",

    REMOVE_ONLINE_PRESENCE: "REMOVE_ONLINE_PRESENCE",
    ADD_CHUNK_ONLINE_PRESENCE: "ADD_CHUNK_ONLINE_PRESENCE",

    SET_SIDEBAR_BUSY: "SET_SIDEBAR_BUSY",

    SET_MESSAGES: "SET_MESSAGES",
    ADD_READ_MESSAGES: "ADD_READ_MESSAGES",
    UPDATE_CONV_LIST_ONLINE_STATUS: "UPDATE_CONV_LIST_ONLINE_STATUS",
    UPDATE_USER_FILTER: "UPDATE_USER_FILTER",
    UPDATE_MESSENGER_SEARCH_FILTER: "UPDATE_MESSENGER_SEARCH_FILTER",

    SET_PERSONAL_NOTES_IS_BUSY: "SET_PERSONAL_NOTES_IS_BUSY",
    SET_PERSONAL_NOTES_IS_OPEN: "SET_PERSONAL_NOTES_IS_OPEN",
    SET_ACTIVE_PERSONAL_NOTE: "SET_ACTIVE_PERSONAL_NOTE",
    RESET_PERSONAL_NOTE: "RESET_PERSONAL_NOTE",

    SET_TEMP_STASH_SELECTED: "SET_TEMP_STASH_SELECTED",

    USER_FETCHING: "USER_FETCHING",

    UPDATE_BROADCAST_INDICATOR: "UPDATE_BROADCAST_INDICATOR",

    SET_VIDEO_PLAYER_IS_PLAYING: "SET_VIDEO_PLAYER_IS_PLAYING",
    SET_VIDEO_PLAYER_ID: "SET_VIDEO_PLAYER_ID",
    SET_VIDEO_PLAYER_SOURCE: "SET_VIDEO_PLAYER_SOURCE",

    PREPEND_MEDIA_TO_MEDIAS: "PREPEND_MEDIA_TO_MEDIAS",
    RESET_STASH_MEDIAS: "RESET_STASH_MEDIAS",

    SET_CC_FORM: "SET_CC_FORM",
    TOGGLE_CC_FORM: "TOGGLE_CC_FORM",

    UPDATE_USER_STORE: "UPDATE_USER_STORE",
    SET_POST_KW: "SET_POST_KW",

    SET_TRENDING: "SET_TRENDING",
    SET_TRENDING_KEYWORD: "SET_TRENDING_KEYWORD",
    RESET_TRENDINGS: "RESET_TRENDINGS",
    SET_TRENDINGS_BUSY: "SET_TRENDINGS_BUSY",
    SET_TRENDINGS_TOTAL: "SET_TRENDINGS_TOTAL",
    NO_RELOAD_UPDATE_TRENDINGS: "NO_RELOAD_UPDATE_TRENDINGS",

    SET_SEARCH: "SET_SEARCH",
    SET_SEARCH_KEYWORD: "SET_SEARCH_KEYWORD",
    RESET_SEARCH: "RESET_SEARCH",
    SET_SEARCH_BUSY: "SET_SEARCH_BUSY",
    SET_SEARCH_TYPE: "SET_SEARCH_TYPE",
    SET_SEARCH_USERS: "SET_SEARCH_USERS",
    SET_SEARCH_HAS_MORE: "SET_SEARCH_HAS_MORE",
    SET_SEARCH_TOTAL: "SET_SEARCH_TOTAL",
    RESET_SEARCH_RESULT: "RESET_SEARCH_RESULT",

    REFETCH_PROMOTIONS: "REFETCH_PROMOTIONS",
    SET_FREE_TRIAL_IS_BUSY: "SET_FREE_TRIAL_IS_BUSY",
    SET_FREE_TRIAL_PROMOTIONS: "SET_FREE_TRIAL_PROMOTIONS",
    SET_DISCOUNTED_PROMOTIONS: "SET_DISCOUNTED_PROMOTIONS",

    SET_STASH_RESET: "SET_STASH_RESET",

    SET_USER_LISTS_BUSY: "SET_USER_LISTS_BUSY",
    SET_USER_LISTS: "SET_USER_LISTS",
    APPEND_USER_LISTS: "APPEND_USER_LISTS",
    SET_ACTIVE_USER_LIST: "SET_ACTIVE_USER_LIST",
    SET_USER_LIST_USERS_BUSY: "SET_USER_LIST_USERS_BUSY",
    SET_USER_LIST_USERS: "SET_USER_LIST_USERS",
    APPEND_USER_LIST_USERS: "APPEND_USER_LIST_USERS",
    SET_USER_LIST_PAGE: "SET_USER_LIST_PAGE",
    SET_USER_LISTS_HAS_MORE: "SET_USER_LISTS_HAS_MORE",
    SET_USER_LISTS_TOTAL: "SET_USER_LISTS_TOTAL",
    SET_USER_LIST_USERS_TOTAL: "SET_USER_LIST_USERS_TOTAL",
    REMOVE_USER_LIST_USER: "REMOVE_USER_LIST_USER",
    SET_USER_LIST_USER_PAGE: "SET_USER_LIST_USER_PAGE",
    RESET_USER_LISTS: "RESET_USER_LISTS",
    PREPEND_USER_LISTS: "PREPEND_USER_LISTS",
    REMOVE_USER_LIST: "REMOVE_USER_LIST",
    UPDATE_USER_LIST: "UPDATE_USER_LIST",
    TOGGLE_USER_LIST_MODAL: "TOGGLE_USER_LIST_MODAL",
    RESET_USER_LIST_USERS: "RESET_USER_LIST_USERS",

    SET_MESSAGE_USER_LISTS: "SET_MESSAGE_USER_LISTS",
    RESET_MESSAGE_USER_LISTS: "RESET_MESSAGE_USER_LISTS",
    SET_SHOW_MESSAGE_USER_LISTS: "SET_SHOW_MESSAGE_USER_LISTS",
    SET_PROFILE: "SET_PROFILE",
    GET_PROFILE: "GET_PROFILE",

    UPDATE_POST_BY_TYPE: "UPDATE_POST_BY_TYPE",

    POST_THANK_YOU: "POST_THANK_YOU",

    SET_APP_SETTING: "SET_APP_SETTING",
    SET_ACTIVE_MESSAGE: "SET_ACTIVE_MESSAGE",
    SET_STASH_SOURCE: "SET_STASH_SOURCE",

    TOGGLE_TIP: "TOGGLE_TIP",
    SET_TIP_POST_ID: "SET_TIP_POST_ID",
    SET_TIP_NEXT_ACTION: "SET_TIP_NEXT_ACTION",
};

export default ActionTypes;
